export const TEXTO_OMISSIS = '...........................................................................................';
